import React, { Fragment } from 'react';

import { Flag } from 'lucide-react';

import { InsightPriority } from 'common/constants/insights';
import { cn } from 'common/style/utils';
import HStack from 'common/uiV3/HStack';
import { Select, type SelectBaseOption } from 'common/uiV3/Select';

const InsightPriorityOptions = [
  {
    label: 'Nice to have',
    color: 'bg-blue-90',
    value: InsightPriority.NiceToHave,
  },
  {
    label: 'Important',
    color: 'bg-orange-90',
    value: InsightPriority.Important,
  },
  {
    label: 'Must have',
    color: 'bg-purple-90',
    value: InsightPriority.MustHave,
  },
  {
    label: 'No priority',
    color: 'bg-gray-110',
    value: InsightPriority.NoPriority,
  },
] as const;

export default function PrioritySelect({
  onChange,
  priority,
}: {
  onChange: (value: InsightPriority | null) => void;
  priority: InsightPriority | null;
}) {
  const options = InsightPriorityOptions.map((option) => ({
    label: <PrioritySelectOption option={option} flair={option.color} />,
    value: option.value,
  }));

  const onSelect = (value: string | undefined) =>
    onChange(value !== InsightPriority.NoPriority ? (value as InsightPriority) : null);

  return (
    <Select
      options={options}
      placeholder={
        <Fragment>
          <Flag /> Priority
        </Fragment>
      }
      fullWidth
      value={priority || undefined}
      onValueChange={onSelect}
    />
  );
}

const PrioritySelectOption = ({ option, flair }: { option: SelectBaseOption; flair: string }) => {
  return (
    <HStack className="items-center gap-2">
      <div className={cn(flair, 'w-2 h-2 rounded-full')} />
      {option.label}
    </HStack>
  );
};
